(ns manatee.components.editors.subs
  (:require [manatee.components.editors.app-db :as editors-db]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::spelling-dictionary
 (fn spelling-dictionary
   [db _]
   (editors-db/spelling-dictionary db)))

(rf/reg-sub
 ::misspelled-words
 (fn misspelled-words
   [db _]
   (editors-db/misspelled-words db)))
